<template>
<div>
    <!-- <top-bar></top-bar> -->
    <top-slider></top-slider>
    <top-menu></top-menu>

    <div class="page_content_box">
        <div class="wrap">
            <div class="detail">
                <h1>{{detailContent.title}}</h1>
                <div class="source">
                    <div class="left">
                    <span>发布日期:</span>{{ detailContent.date }}
                    <!-- <span style="margin-left:20px;">来源:</span>{{ detailContent.source !==null ? detailContent.source : '' }} -->
                    </div>
                    <div class="right">
                    <h3>分享到:</h3>
                    <el-popover
                        placement="bottom"
                        width="300"
                        trigger="click">
                        <QRCode :QRtitle="'扫一扫在手机打开当前页'" ></QRCode>
                        <div class="toWx" slot="reference"></div>
                    </el-popover>
                    <div class="toWb" @click="shareWeibo"></div>
                    <div class="toQzone" @click="shareQzone"></div>
                    </div>
                </div>
                <div class="content">
                    <div class="line">
                        <div class="title">
                            <h2>咨询信息</h2>
                            <div class="date"><span>咨询日期:</span>{{detailContent.date}}</div>
                        </div>
                        <div class="desc" v-html="detailContent.content"></div>
                    </div>
                    <div class="line">
                        <div class="title">
                            <h2>回复信息</h2>
                            <div class="date"><span>回复日期:</span>{{detailContent.replyTime}}</div>
                        </div>
                        <div class="desc" v-html="detailContent.replyContent"></div>
                    </div>                    
                </div>
                <!-- 二维码 -->
                <QRCode :QRtitle="'扫一扫在手机打开当前页'" ></QRCode>
            </div>
        </div>
    </div>
    <Footer></Footer>
</div>
</template>

<script>
import { getConsultDetail } from '@/service/api.js'
import * as util from '@/utils/util.js'
import TopMenu from '@/components/TopMenu.vue'
// import TopBar from '@/components/TopBar.vue'
import Footer from '@/components/Footer.vue'
import TopSlider from '@/components/TopSlider.vue'
import QRCode from '@/components/QRCode.vue'
export default {
  // components: { TopMenu,TopBar,Footer,TopSlider, QRCode },
  components: { TopMenu,Footer,TopSlider, QRCode },
    data() {
        return {
            detailContent:{
                title:'',
                date:'',
                content:'',
                replyContent:'',
                replyTime:''
            },
            showFiles:false,
        }
    },
    mounted () {
        getConsultDetail('?consultAskId='+this.$route.params.id).then(data=>{
            console.log(data);
            if (data.code !== 0) {
                this.$message.error(data.msg)
            }else{
                this.detailContent.title = data.data.title;
                this.detailContent.date = util.dateFormat(data.data.questionTime,'Y年M月D日 H:I');
                this.detailContent.content = data.data.content;
                this.detailContent.replyContent = data.data.replyRespVO.replyContent
                this.detailContent.replyTime = util.dateFormat(data.data.replyRespVO.replyTime,'Y年M月D日 H:I');

                // 添加meta标签
                let temp = {
                  'ColumnName': this.detailContent.typeName,
                  'ColumnType': this.detailContent.typeName,
                  'ArticleTitle': this.detailContent.title,
                  'PubDate': this.detailContent.date,
                  'ContentSource': this.detailContent.source,
                  'Author': this.detailContent.author
                }
                util.createContentMeta(temp)
            }
        });
    },
  methods: {
    // 分享到新浪微博
    shareWeibo (event) {
      event.preventDefault()
    // shareUrl是微博的分享地址，（有资料说需要真实的appkey，必选参数，这里我没用appkey也可以正常分享）
      var _shareUrl = 'http://service.weibo.com/share/share.php?' 
      _shareUrl += 'url=' + encodeURIComponent(location.href) //参数url设置分享的内容链接
      _shareUrl += '&title=' + encodeURIComponent(this.detailContent.title) //参数title设置分享的标题
      // 保留当前页面,打开一个非tab页面（按需求来，可以新开标签页，也可以在当前页新开页面）
      window.open(
        _shareUrl,
        '_blank',
        'height=100, width=400',
        'scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes'
      )
    },
    //分享到QQ空间
    shareQzone (event){
      event.preventDefault()
    // shareUrl是微博的分享地址，（有资料说需要真实的appkey，必选参数，这里我没用appkey也可以正常分享）
      var _shareUrl = 'https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?' 
      _shareUrl += 'url=' + encodeURIComponent(location.href) //参数url设置分享的内容链接
      _shareUrl += '&title=' + encodeURIComponent(this.detailContent.title) //参数title设置分享的标题
      // 保留当前页面,打开一个非tab页面（按需求来，可以新开标签页，也可以在当前页新开页面）
      window.open(
        _shareUrl,
        '_blank',
        'height=100, width=400',
        'scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes'
      )
    }
  },
}
</script>

<style lang="less" scoped>
.detail {
    padding: 0 50px 50px;
    overflow: hidden;
    min-height: 600px;
    h1 {
        font-size: 24px;
        line-height: 1.4;
        margin-top: 40px;
        text-align: center;
    }
  .source {
    font-size: 14px;
    text-align: center;
    line-height: 1;
    margin-top: 20px;
    color: #999;
    overflow: hidden;
    .left {
      float: left
    }
    .right {
      float: right;
      overflow: hidden;
      h3 {
        float: left;
        line-height: 30px;
      }
      .toWx {
        width: 18px;
        height: 18px;
        float: left;
        cursor: pointer;
        margin-left: 10px;
        margin-top: 5px;
        background: url(../../assets/images/wxShare.png) no-repeat;
        border-radius: 9px;
        &:hover {
          background: url(../../assets/images/wxShare_on.png) no-repeat;
        }
      }
      .toWb {
        width: 18px;
        height: 18px;
        float: left;
        cursor: pointer;
        margin-left: 10px;
        margin-top: 5px;
        background: url(../../assets/images/wbShare.png) no-repeat;
        border-radius: 9px;
        &:hover {
          background: url(../../assets/images/wbShare_on.png) no-repeat;
        }
      }
      .toQzone {
        width: 18px;
        height: 18px;
        float: left;
        cursor: pointer;
        margin-left: 10px;
        margin-top: 5px;
        background: url(../../assets/images/qzoneShare.png) no-repeat;
        border-radius: 9px;
        &:hover {
          background: url(../../assets/images/qzoneShare_on.png) no-repeat;
        }
      }
    }
  }
    .content {
        margin-top: 20px;
        line-height: 2;
        text-align: justify;
        img {
            max-width: 1100px;
        }
        .line {
            flex-direction: column;
            .title {
                border-bottom: dashed 1px #999;
                padding-bottom: 10px;
                height: 30px;
                line-height: 30px;
                width: 100%;
                h2 {
                    font-size: 18px;
                    font-weight: 600;
                    display: block;
                    float: left;
                    width: 200px;
                    height: 30px;
                }
                .date {
                    float: right;
                    width: 300px;
                    color: #999;
                    text-align: right;
                    font-size: 16px;
                    span {
                        color: #333;
                    }
                }
            }
            .desc {
                margin: 20px 0;
                line-height: 2;
                text-indent: 2em;
                font-size: 16px;
            }
        }
    }
}
</style>